module.exports = __webpack_public_path__ + "static/media/popupBG.6d296191.png";